import React from "react";
import { Box } from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import { ResponsivePage } from "../../../components/desktopUi";
import { MenuCard, MenuGrid } from "../../../components/managementUi";
import { appImages } from "../../../assets/appicons";
import { EMP_BASE_PATH } from "../../../config";

// Khớp app: app/(feature)/management/staff/employee/index.tsx
// Bấm 1 nhân viên trong danh sách -> màn menu 3 chức năng, không vào thẳng chi tiết.
const StaffEmployeeMenu = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  return (
    <ResponsivePage title="Quản lý nhân viên">
      <MenuGrid>
        <MenuCard
          icon={appImages.icon_HDMB}
          label="Thông tin"
          onClick={() => navigate(`${EMP_BASE_PATH}/quan-ly/nhan-vien/${id}/thong-tin`)}
        />
        <MenuCard
          icon={appImages.icon_cham_cong}
          label="Chuyên cần"
          onClick={() => navigate(`${EMP_BASE_PATH}/bao-tri`)}
        />
        <MenuCard
          icon={appImages.icon_dang_ky_chuen_GD}
          label="Giao dịch"
          onClick={() => navigate(`${EMP_BASE_PATH}/bao-tri`)}
        />
      </MenuGrid>
    </ResponsivePage>
  );
};

export default StaffEmployeeMenu;
